globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateReminder = (function(superClass)
{
    utils.extend(ModalCreateReminder, superClass);

    function ModalCreateReminder($html) {
      return ModalCreateReminder.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCreateReminder.prototype, {
      init: function() {
        var self = this;

        autosize(this.$html.find('.elastic'));
        this.$html.find('[data-popup="tooltip"]').tooltip();
        this.$html.find('.select-search').select2();

        this.$html.find('.daterange-single').daterangepicker({
          singleDatePicker: true,
          timePicker: true,
          timePicker24Hour: true,
          locale: {
            format: 'DD/MM/YYYY LT'
          }
        });

        this.$html.on('click', '.set-current-page', function() {
          self.$html.find('.notification-link').val(window.location.href);
        });

        this.$html.on('focus', 'input.notification-link', function() {
            $(this).select();
        });

        ModalCreateReminder.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          window.location.href = this.$html.data('redirect-url')
        }

        ModalCreateReminder.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalCreateReminder;
})(backoffice.ModalMain);
